import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/a2ui-gallery/components')({
  beforeLoad: () => {
    throw Route.redirect({ to: '/a2ui-gallery', replace: true, statusCode: 301 });
  },
});
